var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "section",
        {
          directives: [
            {
              name: "htmlclass",
              rawName: "v-htmlclass",
              value: _vm.customHtmlClasses,
              expression: "customHtmlClasses"
            }
          ],
          staticClass: "modal",
          class: {
            "modal--light": _vm.light,
            "modal--narrow": _vm.narrow,
            "modal--full-height": _vm.fullHeight,
            "modal--full-screen": _vm.fullScreen
          },
          attrs: { id: _vm.id }
        },
        [
          !_vm.fullScreen
            ? _c("div", { staticClass: "modal__backdrop" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "wrapper",
              staticClass: "modal__wrapper",
              class: {
                "modal__wrapper--full-screen": _vm.fullScreen
              },
              on: { click: _vm.closeFromWrapper }
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal__window",
                  class: {
                    "modal__window--light": _vm.light,
                    "modal__window--narrow": _vm.narrow,
                    "modal__window--full-height": _vm.fullHeight,
                    "modal__window--full-screen": _vm.fullScreen,
                    "modal__window--no-padding": _vm.noPadding
                  }
                },
                [
                  !_vm.noClose
                    ? _c(
                        "button",
                        {
                          staticClass: "modal__close",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.close(_vm.softClose)
                            }
                          }
                        },
                        [_c("SVGClose")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal__content" },
                    [
                      _vm._t("default", null, {
                        closeModal: function() {
                          return _vm.close(_vm.softClose)
                        }
                      })
                    ],
                    2
                  )
                ]
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }